// สถานะส่ง CS ของเคลม
// API ส่ง sendCsStatusLabel มาจาก procedure ซึ่งนับเฉพาะ SENDED (ค่าของระบบเดิม) ว่าส่งแล้ว
// แต่ระบบส่ง CS ปัจจุบันบันทึก SUCCESS จึงต้องคำนวณป้ายเองจาก sendCsStatus และเลข CS
export const SEND_CS_SENT_STATUSES = ['SUCCESS', 'SENDED'];

export const SEND_CS_LABEL = {
  SENT: 'ส่งแล้ว',
  FAILED: 'ส่งไม่ผ่าน',
  NOT_SENT: 'ยังไม่ส่ง',
};

const normalize = (value) =>
  String(value || '')
    .trim()
    .toUpperCase();

export const hasCsNumber = (record) => !!String(record?.refCsId || '').trim();

export const isCsSent = (record) =>
  SEND_CS_SENT_STATUSES.includes(normalize(record?.sendCsStatus)) || hasCsNumber(record);

export const getSendCsLabel = (record) => {
  if (isCsSent(record)) return SEND_CS_LABEL.SENT;
  if (normalize(record?.sendCsStatus) === 'FAILED') return SEND_CS_LABEL.FAILED;
  return SEND_CS_LABEL.NOT_SENT;
};
